import React from "react";
import Split from 'react-split-it';
import 'components/SplitGrid.css';

export function SplitColumns(props) {    
    return <Split gutterSize={10} {...props}/>
}

export function SplitRows(props) {    
    return <Split gutterSize={10} direction="vertical" {...props}/>
}